import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from "../../action/AccountAction";
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from 'moment';
import TooltipNotes from "../../Tooltip/Tooltip";
import { history } from "../../helpers/history";

class Transaction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverDate: new Date(),
            creditStatus: 0,
            creditStatus1: 0,
            creditStatus2: 0,
            currentPageNo: 0,
            NumberofRecord: 5,
            totalPage: 0,
            startinx: 0,
            endinx: 10,
            lfilterdt: [],
            startDate: moment().subtract(29, 'days'),
            endDate: moment(),
            Alloption: [
                { "name": this.props.t("lblAll"), "id": "0" },
                { "name": this.props.t("lblCredit"), "id": "1" },
                { "name": this.props.t("lbldebit"), "id": "2" },
                { "name": this.props.t("lblPurchase"), "id": "3" }
            ],
            SelectGame: '0'
        };
    }

    handleCallback = (start, end) => {
        if (start && end) {
            this.setState(
                {
                    startDate: start.format('DD/MM/YYYY'),
                    endDate: end.format('DD/MM/YYYY'),
                },
                () => {
                    this.onchangeDate(this.state.startDate, this.state.endDate);
                }
            );
        }
    };


    componentDidMount() {
        this.handleCallback(this.state.startDate, this.state.endDate)
        // window.Loaddaterange(1);
        // var lstrdate = document.getElementById('mydaterange').value;
        // this.onchangeDate(lstrdate);
        // window.getdateFromJS(this.onchangeDate);
        // localStorage.setItem('atabId', 6); this code is using in Account Component
        //setTimeout(() => { this.LoadTransactionData() }, 100);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.TransactionData !== prevProps.TransactionData || this.state.NumberofRecord !== prevState.NumberofRecord) {
            this.LoadTransactionData()
        }
    }
    static getDerivedStateFromProps(props, state) {
        return {
            TransactionData: props.TransactionData
        };
    };
    onchangeDate = (fdate, tdate) => {
        // var fdate = ldate.split('-')[0].trim();
        // var tdate = ldate.split('-')[1].trim();
        let checkdate = this.validatedate(fdate, tdate);
        if (checkdate) {
            this.props.GetTransactiondel(0, fdate, tdate, 2, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        }
    }
    validatedate = (fromDate, toDate) => {
        let datepattern = /(\d{2})\/(\d{2})\/(\d{4})/;
        var fr = (new Date(fromDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
        var to = (new Date(toDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
        var currDate = ("0" + this.state.serverDate.getDate()).slice(-2) + "/" + ("0" + (this.state.serverDate.getMonth() + 1)).slice(-2) + "/" + this.state.serverDate.getFullYear();
        var lserverDate = (new Date(currDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));

        if (fr > lserverDate || to > lserverDate) {
            this.showMsg('lblNoFuturedate');
            return false;
        }
        return true;
        if (fr > to) {
            this.showMsg('lblFromdateNotGreater');
            return false;
        }
        fr.setHours(0, 0, 0, 0);
        to.setHours(0, 0, 0, 0);
        if (fr > to || fr < to) {
            var date = this.state.serverDate;
            var ss = ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear();
            var cdate = new Date(new Date(ss.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            var lfr = ("0" + fr.getDate()).slice(-2) + "/" + ("0" + (fr.getMonth() + 1)).slice(-2) + "/" + fr.getFullYear();
            var lto = ("0" + to.getDate()).slice(-2) + "/" + ("0" + (to.getMonth() + 1)).slice(-2) + "/" + to.getFullYear();
            var fdate = new Date(new Date(lfr.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            var tdate = new Date(new Date(lto.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            cdate.setHours(0, 0, 0, 0);
            fdate.setHours(0, 0, 0, 0);
            tdate.setHours(0, 0, 0, 0);
            if (fdate > cdate && tdate > cdate) {
                this.showMsg('lblCurrentDate');
                return false;
            }
        }
        return true;
    }
    showMsg = (lstrError) => {
        this.props.alertError(this.props.t(lstrError));
    }
    chkbtnClick = () => {
        setTimeout(() => {
            this.LoadTransactionData();
        }, 300);
    }
    LoadTransactionData = () => {
        if (this.state.TransactionData && this.state.TransactionData.result && this.state.TransactionData.result.length > 0) {
            let ldt = []
            if (this.state.SelectGame != "0") {
                ldt = this.state.TransactionData.result.filter(filterData => {
                    return filterData.payment_type == this.state.SelectGame
                });
            }
            else {
                ldt = this.state.TransactionData.result;
            }
            this.setState({ lfilterdt: ldt });
            let ltotpage = Math.trunc(ldt.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(ldt.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }
    loadnxtdata = (st) => {
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        else if (st == "first") {
            this.state.currentPageNo = 0;
        }
        else if (st == "last") {
            this.state.currentPageNo = this.state.totalPage;
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }

    setFilterbyGame = (event) => {
        this.setState({ SelectGame: event.target.value })
    }

    RefreshData = () => {
        // this.setState({ SelectGame: "0" })
        // this.state.SelectGame = "0";
        // this.chkbtnClick();
        window.location.reload(true);
    }

    handleChange = (event) => {
        let newLimit = event.target.value == '0' ? this.state.TransactionData.result.length : event.target.value;
        this.setState({ NumberofRecord: newLimit });
    };

    render() {
        debugger
        const { t } = this.props;
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        <title>Gulf Ticket : Transaction</title>
                        <meta name="description" content="Gulf Ticket Transaction" />
                    </Helmet>
                }
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-transactions.png" /> {t('lblTransaction')}</h1>
                    <div class="proChangePass" onClick={() => { this.props.UpdateJackpotFlag() }}> {t('lbljacpotwinner')}</div>
                </div>
                <div className="orders">
                    <div className="filters">
                        <div class="filtersCont">
                            <div>
                                <label>{t('lblType')}</label>
                                <select class="custom-select" onChange={this.setFilterbyGame}>
                                    <option value="" disabled>{t('lblSel')}</option>
                                    {this.state.Alloption.map((option) => (
                                        <option key={option.id} value={option.id} >
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <span>
                                <label>{t('lblsearchdate')}</label>
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: this.state.startDate,
                                        endDate: this.state.endDate,
                                        locale: {
                                            format: 'DD/MM/YYYY',
                                            separator: ' - ',
                                            applyLabel: 'Apply',
                                            cancelLabel: 'Cancel',
                                        },
                                    }} onCallback={this.handleCallback}
                                >
                                    <input id='datepicker1' value={`${this.state.startDate} - ${this.state.endDate}`} readOnly />
                                </DateRangePicker>
                            </span>
                        </div>
                        <div class="filtersBtn">
                            <a onClick={() => { this.chkbtnClick() }}>{t('lblapply')}</a>
                            <a onClick={() => { this.RefreshData() }}><img src="./assets/img/icons/refresh.png" /></a>
                        </div>
                    </div>

                    {this.state.lfilterdt && this.state.lfilterdt.length > 0 && <div className="table margin-top-20">
                        <ul class="transTble">
                            <li>
                                <div class="w-15 text-left">{t('lblID')}</div>
                                <div class="w-15 text-left">{t('lblDateTime')}</div>
                                <div class="w-25 text-left">{t('lblType')}</div>
                                <div class="w-15 text-left">{t('lblAmt')}</div>
                                <div class="w-15 text-left">{t('lblStatus')}</div>
                                <div class="w-15 text-left">{t('lblCurrency')}</div>
                            </li>
                            {this.state.lfilterdt && this.state.lfilterdt.length > 0 && this.state.lfilterdt.slice(this.state.startinx, this.state.endinx).map((data, index) =>
                                <li key={`bp_${index}`}>
                                    <div class="w-15">{data.transaction_id}</div>
                                    <div class="w-15">{data.transaction_date_time}</div>
                                    <div class="w-25">{data.transaction_type}</div>
                                    <div class="w-15">{process.env.REACT_APP_CURRENCY} {data.amount}</div>
                                    <div class="w-15"><p class={`${data.status_code == 1 ? 'successLbl' : 'failedLbl'}`}>{data.transaction_status}</p></div>
                                    <div class="w-15">{data.other_money}</div>
                                </li>
                            )}
                        </ul>
                        <div class="footCartbuy">
                            <div>{t('lbltotal')} :</div>
                            <span>{this.props.appvariables.currency} {commonClass.aedCrnyConvert(this.state.TransactionData.result.reduce((sum, tx) => sum + parseFloat(tx.amount), 0))}</span>
                        </div>
                        <div class="pagination">
                            <div class="paginationLft">
                                {t('lblshowing')} <span>{this.state.currentPageNo + 1}</span> {t('lblto')} <span>{this.state.TransactionData.result && Math.ceil(this.state.TransactionData.result.length / this.state.NumberofRecord)}</span> {t('lblof')} <span>{this.state.TransactionData.result && this.state.TransactionData.result.length}</span>  {t('lblentries')}
                            </div>
                            <div class="filters4">
                                <div class="filtersCont4">
                                    <div>
                                        <select class="custom-select" value={this.state.NumberofRecord} onChange={this.handleChange}>
                                            <option value="0"  >All</option>
                                            <option value="5" selected>5</option>
                                            <option value="10">10</option>
                                            <option value="50">50</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="paginationLRht">
                                <a onClick={() => this.loadnxtdata("first")}><img src="./assets/img/icons/paginate-2-lft.png" /></a>
                                <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                                <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                                <a onClick={() => this.loadnxtdata("last")} class="" ><img src="./assets/img/icons/paginate-2-rht.png" /></a>
                            </div>
                        </div>
                    </div>}
                </div>
                {(!this.state.TransactionData || !this.state.TransactionData.result || this.state.TransactionData.result == 0) &&
                    <div class="noOrders">
                        <img src="./assets/img/icons/sad.png" />
                        <h3>{t('lblnotransaction')}</h3>
                        <p class="margin-bottom-20">{t('lbladdthings')}</p>
                        <div class="formCont updateBtn">
                            <button onClick={() => {
                                localStorage.setItem('atabId', 3); setTimeout(() => { history.push('/Account') }, 300);
                            }}>{t('lblAddCredit')}</button>
                        </div>
                    </div>}

            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { TransactionData } = state.accountReducer;
    const { Amtrestnotes } = state.gameReducer;
    return { user, TransactionData, appvariables, Amtrestnotes };
}
const mapActionToProps = {
    alertError: alertActions.error,
    GetTransactiondel: accountActions.GetTransactionDel
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Transaction))
